import { render, staticRenderFns } from "./CompetitorsLimitManagement.vue?vue&type=template&id=4d511953&scoped=true&"
import script from "./CompetitorsLimitManagement.vue?vue&type=script&lang=js&"
export * from "./CompetitorsLimitManagement.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorsLimitManagement.vue?vue&type=style&index=0&id=4d511953&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d511953",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
